import React, { useState, useEffect, useRef } from "react";

const DISPLAY_TYPES = {
    STAMINA: "stamina",
    STUNNED: "stunned",
    RESPAWN: "respawn",
    CASTING: "casting",
};

function getDisplayType(time, duration, type) {
    const cur = (time / 1000).toFixed(1);
    const dur = (duration/1000).toFixed(1);
    const timeStr = `${cur}s / ${dur}s`;

    switch (type.toLowerCase()) {
        case DISPLAY_TYPES.STAMINA:
            return <p>Stamina: {cur >= dur ? 'Ready' : timeStr}</p>;
        case DISPLAY_TYPES.STUNNED:
            return <p>Stunned: {timeStr}</p>;
        case DISPLAY_TYPES.RESPAWN:
            return <p>Resurrect in {(dur-cur).toFixed(0)} seconds</p>;
        default:
            return <p>Casting: {timeStr}</p>;
    }
}

function StaminaBar({ stamina }) {
    const startTime = useRef(Date.now());
    const [isTimerActive, setIsTimerActive] = useState(true);
    const [width, setWidth] = useState("0%");
    const [timeLeft, setTimeLeft] = useState(0);

    useEffect(() => {
        let intervalId;
        if (isTimerActive) {
            intervalId = setInterval(() => {
                const currentTime = Date.now();
                const elapsedMilliseconds = currentTime - startTime.current;
                if (elapsedMilliseconds >= stamina.duration) {
                    setIsTimerActive(false);
                    startTime.current = currentTime; 
                }
                setWidth(`${(elapsedMilliseconds * 100) / stamina.duration}%`);
                setTimeLeft(getDisplayType(elapsedMilliseconds, stamina.duration, stamina.type));
            }, 100);
        }

        return () => clearInterval(intervalId);
    }, [isTimerActive, stamina.duration, stamina.type]);

    useEffect(() => {
        startTime.current = Date.now();
        setIsTimerActive(true);
    }, [stamina]);

    return (
        <div className="vitals">
            <div className="stamina-outer">
                <div
                    className={`stamina-inner ${stamina.type.toLowerCase()}`}
                    style={{ width: isTimerActive ? width : '100%' }}
                ></div>
                <div className="health-info">
                    {timeLeft}
                </div>
            </div>
        </div>
    );
}

export default StaminaBar;